import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'ramda';
import { withTranslation } from 'react-i18next';
import { mapIndex } from 'utilities/ramda';
import AdaptiveDataRow from './AdaptiveDataRow';

const AdaptiveDataBlock = ({ className, data, t, ...rest }) =>
  map(
    ({ title, items }) => (
      <AdaptiveDataRow key={title} className={className} title={t(title)} {...rest}>
        {mapIndex(
          ({ title: itemTitle, value }, index) => (
            <div key={index}>
              {itemTitle && `${t(itemTitle)}: `}
              {value}
            </div>
          ),
          items,
        )}
      </AdaptiveDataRow>
    ),
    data,
  );

AdaptiveDataBlock.defaultProps = {
  className: null,
};

AdaptiveDataBlock.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          value: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

export default withTranslation()(AdaptiveDataBlock);
